
<img *ngIf="!activeStream" alt="" [attr.src]="'/img/placeholder.png'">

<video #camVideo *ngIf="cameraStream" [hidden]="activeStream !== cameraStream" autoplay [muted]="!cameraVolume" [volume]="cameraVolume" [srcObject]="cameraStream" (canplay)="checkVideos()" (pause)="checkVideos()">
</video>

<video #shareVideo *ngIf="captureStream" [hidden]="activeStream !== captureStream" autoplay [muted]="!captureVolume" [volume]="captureVolume" [srcObject]="captureStream" (canplay)="checkVideos()" (pause)="checkVideos()">
</video>

<div dropdown vbDropdown container="body" [ngClass]="styles.dropdown" [hidden]="!showMenu" [dropup]="true">
	<button type="button" dropdownToggle [class]="styles.dropdownToggle">
		<i class="glyphicons more"></i>
	</button>
	<div *dropdownMenu [ngClass]="[styles.dropdownMenu, styles.dropUp]" class="dropdown-menu dropdown-menu-right">
		<ng-container *ngIf="canEditLayout && backstageStreamTypes">
			<ng-container *ngIf="showToggleSpeaker()">
				<button type="button" class="dropdown-item" *ngIf="backstageStreamTypes.speaker; else addSpeakerMenu" (click)="removePresenter(StreamType.Speaker)">
					{{ (backstageStreamTypes.speakerBg ? 'Event_Producer_PresenterRemoveBgCamera' : 'Event_Producer_PresenterRemoveCamera') | translate }}
				</button>

				<ng-template #addSpeakerMenu>
					<button type="button" class="dropdown-item" (click)="addPresenter(StreamType.Speaker)">
						{{ 'Event_Producer_PresenterAddCamera' | translate }}
					</button>
					<button type="button" class="dropdown-item" (click)="addPresenter(StreamType.Speaker, true)">
						{{ 'Event_Producer_PresenterAddCameraBg' | translate }}
					</button>
				</ng-template>
			</ng-container>

			<button type="button" class="dropdown-item" *ngIf="showToggleAudio()" (click)="toggleLayoutAudio()">
				{{ (backstageStreamTypes.audio ? 'Event_Producer_PresenterRemoveAudio' : 'Event_Producer_PresenterAddAudio') | translate }}
			</button>

			<ng-container *ngIf="showToggleContent()">
				<button type="button" class="dropdown-item" *ngIf="backstageStreamTypes.content; else addContentMenu" (click)="removePresenter(StreamType.Content)">
					{{ (backstageStreamTypes.contentBg ? 'Event_Producer_PresenterRemoveBgScreen' : 'Event_Producer_PresenterRemoveScreen') | translate }}
				</button>
				<ng-template #addContentMenu>
					<button type="button" class="dropdown-item" (click)="addPresenter(StreamType.Content)">
						{{ 'Event_Producer_PresenterAddScreen' | translate }}
					</button>
					<button type="button" class="dropdown-item" (click)="addPresenter(StreamType.Content, true)">
						{{ 'Event_Producer_PresenterAddScreenBg' | translate }}
					</button>
				</ng-template>
			</ng-container>
		</ng-container>
		<button type="button" class="dropdown-item" (click)="toggleMute()">
			{{ (muteAll ? 'Event_Producer_UnmutePresenter' : 'Event_Producer_MutePresenter') | translate }}
		</button>
		<div *ngIf="canPushToTalk" [ngClass]="styles.pushToTalkContainer">
			<button type="button" class="dropdown-item" [ngClass]="endPushToTalk ? styles.activePushTalk : ''" vbPushHold (onStart)="startPushToTalk()" (onStop)="stopPushToTalk()">
				{{ (endPushToTalk
					? 'Event_Producer_PushToTalk_Speaking'
					: 'Event_Producer_PushToTalk_Name' )| translate : { '0': name } }}
			</button>
		</div>
	</div>

</div>

<div [ngClass]="styles.gradient"></div>



<div [ngClass]="styles.bottomRow">

	<div [ngClass]="styles.labelWrap">
		<div [ngClass]="styles.label">
			{{ isProducer ? ('Event_Producer_ProducerLabel' | translate: { '0': name }) : !!presenter.externalPresenterEmail ? ('Event_Producer_ExternalLabel' | translate: { '0': name }) : name }}
		</div>
	</div>

	<button type="button" *ngIf="hasAudio" [disabled]="presenter.muted" [ngClass]="[
			styles.muteButton,
			isMute ? styles.mutedIcon :
			speakerActive ? styles.speakerActiveIcon : ''
		]" (click)="toggleMute()">
		<span class="vb-icon" [ngClass]="isMute ? 'vb-icon-mic-off' : 'vb-icon-mic-on'"></span>
	</button>

	<button type="button" *ngIf="enableToggle" [ngClass]="styles.toggleStreamButton" [title]="(activeStream === cameraStream ? 'Event_Producer_PresenterShowScreen' : 'Event_Producer_PresenterShowCamera') | translate" (click)="toggleStream()">
		<span [ngClass]="iconClass"></span>
	</button>

</div>

